import type { ScaledSize } from 'react-native';
import { Dimensions } from 'react-native';

type GetWindowResult = ScaledSize & {
  layoutMode: 'landscape' | 'portrait';
};

export const getWindowProps = (): GetWindowResult => {
  const window = Dimensions.get('window');
  const { height, width } = window;

  return { ...window, layoutMode: height <= width ? 'landscape' : 'portrait' };
};

export const scale = (
  size: number,
  currentParentSize: number,
  parentReferenceSize: number
): number => size * (currentParentSize / parentReferenceSize);
